import {
  MASS_POSTING_START,
  MASS_POSTING_END,
  MASS_POSTING_RESULTS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const MassPostingTypes = (type, data) => {
  return { type, data };
};

const runMassPostingSimulationAPI = (data, apiPath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apiPath, data, { headers });
};

export const runMassPostingSimulation = (data, apiPath, resultsPath) => {
  return async (dispatch) => {
    dispatch(MassPostingTypes(MASS_POSTING_START));
    try {
      const response = await runMassPostingSimulationAPI(data, apiPath);
      dispatch(MassPostingTypes(MASS_POSTING_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.result && response.data.result.length > 0) {
          dispatch(MassPostingTypes(MASS_POSTING_RESULTS, response.data));
          history.push(resultsPath);
        }
        return { success: !hasError, response };
      } else {
        if (response.data.result && response.data.result.length > 0) {
          dispatch(MassPostingTypes(MASS_POSTING_RESULTS, response.data));
          history.push(resultsPath);
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(MassPostingTypes(MASS_POSTING_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};
